// Partitions
import * as _ from "lodash";
import { Schema } from "js-data";
import * as PASchema from "./PAdbSchema";
import {
    dctLogicalKeysByEntitySet,
    dctMapperToKeyGenSpecs,
    dctNonParentForeignKeysByEntitySet,
    dctSchemaByEntitySet,
    dctTableNameByEntitySet,
    KeyGenSpecs_default,
} from "./PAdbSchema";

export const WB_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Partitions", // optional
    description: "Schema for Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PARTITION_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PARTITION_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        PARTITION_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        COMMENTS: {
            type: "string",
            length: 512,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 512,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESORG_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESAREA_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        HIERARCHY_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CUSTOMER_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        WB_CUSTH_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PRODUCT_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        WB_PRDH_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PERIOD_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        WB_PERIODH_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        SOURCE_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Partition_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_PartitionR]: {
            foreignKey: "WB_PARTITION_ID",
            foreignKeyImmutable: true,
            localField: "PartitionRs",
        },
    },
    belongsTo: {
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
        [PASchema.esWB_Customer_Hierarchy]: {
            foreignKey: "WB_CUSTH_ID",
            foreignKeyImmutable: true,
            localField: "CustomerHierarchy",
        },
        [PASchema.esWB_Product_Hierarchy]: {
            foreignKey: "WB_PRDH_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroupHierarchy",
        },
        [PASchema.esWB_Period_Hierarchy]: {
            foreignKey: "WB_PERIODH_ID",
            foreignKeyImmutable: true,
            localField: "PeriodHierarchy",
        },
    },
};

export const WB_PartitionR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "PartitionRs", // optional
    description: "Schema for PartitionR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_PARTITIONR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PARTITION_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CUST_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PRDGRP_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PERIOD_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SOURCE_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_PartitionR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Partition]: {
            foreignKey: "WB_PARTITION_ID",
            foreignKeyImmutable: true,
            localField: "Partition",
        },
        [PASchema.esWB_Customer]: { foreignKey: "WB_CUST_ID", foreignKeyImmutable: true, localField: "Customer" },
        [PASchema.esWB_Product_Group]: {
            foreignKey: "WB_PRDGRP_ID",
            foreignKeyImmutable: true,
            localField: "ProductGroup",
        },
        [PASchema.esWB_Period]: { foreignKey: "WB_PERIOD_ID", foreignKeyImmutable: true, localField: "Period" },
        [PASchema.esWB_Source]: { foreignKey: "WB_SOURCE_ID", foreignKeyImmutable: true, localField: "Source" },
    },
};

// Control Point Type
export const WB_Control_Point_Type = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point Type", // optional
    description: "Schema for Control Point Type records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINTM_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_TYPE_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_TYPE_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        TREE_PATH: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        PLACEMENT_POLICY: {
            type: "string",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        ENTERPRISE_POLICY: {
            type: "string",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_Type_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_ControlPoint_Type_Process]: {
            foreignKey: "WB_CONTROL_POINTM_ID",
            foreignKeyImmutable: true,
            localField: "Processes",
        },
    },
    belongsTo: {},
};

export const WB_Control_Point_Type_Process = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point Type Process", // optional
    description: "Schema for Control Point Type Process records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINTMPR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTM_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PROCESS_ID: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        PROCESS_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        INPUT_VALUE_METHOD: {
            type: "string",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CUSTOM_PROCESS: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_Type_Process_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_ControlPoint_Type_Process_Input]: {
            foreignKey: "WB_CONTROL_POINTMPR_ID",
            foreignKeyImmutable: true,
            localField: "ProcessInputs",
        },
    },
    belongsTo: {
        [PASchema.esWB_ControlPoint_Type]: {
            foreignKey: "WB_CONTROL_POINTM_ID",
            foreignKeyImmutable: true,
            localField: "ControlPointType",
        },
    },
};

export const WB_Control_Point_Type_Process_Input = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point Type Process Input", // optional
    description: "Schema for Control Point Type Process Input records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINTMPIR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTMPR_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        INPUT_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        REQUIRED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        SORT_ORDER: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_Type_Process_Input_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_ControlPoint_Type_Process]: {
            foreignKey: "WB_CONTROL_POINTMPR_ID",
            foreignKeyImmutable: true,
            localField: "Process",
        },
    },
};

// Control Point
export const WB_Control_Point = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point", // optional
    description: "Schema for Control Point records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINT_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTM_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        COMMENTS: {
            type: "string",
            length: 1333,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1333,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        WB_BUSINESSUNIT_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_COMPANY_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESORG_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESAREA_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_ControlPoint_Partition]: {
            foreignKey: "WB_CONTROL_POINT_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_ControlPoint_Type]: {
            foreignKey: "WB_CONTROL_POINTM_ID",
            foreignKeyImmutable: true,
            localField: "ControlPointType",
        },
        [PASchema.esWB_BusinessUnit]: {
            foreignKey: "WB_BUSINESSUNIT_ID",
            foreignKeyImmutable: true,
            localField: "BusinessUnit",
        },
    },
};

export const WB_Control_Point_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point Partition", // optional
    description: "Schema for Control Point Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINTPR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINT_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PARTITION_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTMPR_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        SORT_ORDER: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_Partition_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_ControlPoint_Partition_Input]: {
            foreignKey: "WB_CONTROL_POINTPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionInputs",
        },
    },
    belongsTo: {
        [PASchema.esWB_ControlPoint]: {
            foreignKey: "WB_CONTROL_POINT_ID",
            foreignKeyImmutable: true,
            localField: "ControlPoint",
        },
        [PASchema.esWB_ControlPoint_Type_Process_Input]: {
            foreignKey: "WB_CONTROL_POINTMPIR_ID",
            foreignKeyImmutable: true,
            localField: "ProcessInput",
        },
    },
};

export const WB_Control_Point_Partition_Input = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Control Point Partition Input", // optional
    description: "Schema for Control Point Partition Input records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CONTROL_POINTPIR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTPR_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CONTROL_POINTMPIR_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        INPUT_VALUE: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Control_Point_Partition_Input_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_ControlPoint_Partition]: {
            foreignKey: "WB_CONTROL_POINTPR_ID",
            foreignKeyImmutable: true,
            localField: "ControlPointPartition",
        },
        [PASchema.esWB_ControlPoint_Type_Process_Input]: {
            foreignKey: "WB_CONTROL_POINTMPIR_ID",
            foreignKeyImmutable: true,
            localField: "ProcessInput",
        },
    },
};

// LE Spend
export const WB_LE_Spend = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "LE Spend", // optional
    description: "Schema for LE Spend records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LE_SPEND_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESORG_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESAREA_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        COMMENTS: {
            type: "string",
            length: 512,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 512,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        WB_AUTHUSR_ID_CREATEDBY: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_LE_Spend_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_LE_Spend_Partition]: {
            foreignKey: "WB_LE_SPEND_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
    },
};

export const WB_LE_Spend_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "LE Spend Partition", // optional
    description: "Schema for LE Spend Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LE_SPENDPR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_LE_SPEND_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PARTITION_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        SORT_ORDER: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});

export const WB_LE_Spend_Partition_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_LE_Spend_Partition_Input]: {
            foreignKey: "WB_LE_SPENDPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionInputs",
        },
    },
    belongsTo: {
        [PASchema.esWB_LE_Spend]: { foreignKey: "WB_LE_SPEND_ID", foreignKeyImmutable: true, localField: "LESpend" },
    },
};

export const WB_LE_Spend_Partition_Input = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "LE Spend Partition Input", // optional
    description: "Schema for LE Spend Partition Input records", // optional
    type: "object",
    track: true,
    properties: {
        WB_LE_SPENDPSR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_LE_SPENDPR_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_EVTSTYPE_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CALC_PROCESS_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        STARTING_METRIC_POLICY: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        ACTUAL_USAGE_POLICY: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        PAID_IN_FULL_POLICY: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        PRODUCT_ALLOCATION: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        TIME_ALLOCATION: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});

export const WB_LE_Spend_Partition_Input_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_LE_Spend_Partition]: {
            foreignKey: "WB_LE_SPENDPR_ID",
            foreignKeyImmutable: true,
            localField: "LESpendPartition",
        },
    },
};

// Spend Actualization
export const WB_Act_Spend = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Spend Actualization", // optional
    description: "Schema for Spend Actualization records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ACT_SPEND_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESORG_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESAREA_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        COMMENTS: {
            type: "string",
            length: 512,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 512,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Act_Spend_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Act_Spend_Partition]: {
            foreignKey: "WB_ACT_SPEND_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
    },
};

export const WB_Act_Spend_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Spend Actualization Partition", // optional
    description: "Schema for Spend Actualization Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ACT_SPENDPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_ACT_SPEND_ID: {
            type: "number",
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
        },
        SORT_ORDER: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Act_Spend_Partition_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Act_Spend_Partition_Input]: {
            foreignKey: "WB_ACT_SPENDPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionInputs",
        },
    },
    belongsTo: {
        [PASchema.esWB_Act_Spend]: { foreignKey: "WB_ACT_SPEND_ID", foreignKeyImmutable: true, localField: "ActSpend" },
    },
};

export const WB_Act_Spend_Partition_Input = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Spend Actualization Partition Input", // optional
    description: "Schema for Spend Actualization Partition Input records", // optional
    type: "object",
    track: true,
    properties: {
        WB_ACT_SPENDPSR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_ACT_SPENDPR_ID: {
            type: "number",
        },
        WB_EVTSTYPE_ID: {
            type: "number",
        },
        CALC_PROCESS_ID: {
            type: "string",
            length: 50,
        },
        ACTUAL_COST_SOURCE: {
            type: "string",
            length: 50,
        },
        RELOCATION_METHOD: {
            type: "string",
            length: 50,
        },
        ALLOCATION_BASIS: {
            type: "string",
            length: 50,
        },
        TIME_ALLOCATION: {
            type: "string",
            length: 50,
        },
        WEEK_START_DAY_OF_WEEK: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_Act_Spend_Partition_Input_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Act_Spend_Partition]: {
            foreignKey: "WB_ACT_SPENDPR_ID",
            foreignKeyImmutable: true,
            localField: "ActSpendPartition",
        },
    },
};

export const WB_Classification = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Classification", // optional
    description: "Schema for Classification records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLASSIFICATION_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            default: 0,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CLASSIFICATION_ID: {
            type: "string",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CLASSIFICATION_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        WB_TAG_CATEGORY_ID: {
            type: "number",
            default: 0,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_TAG_GROUP_ID: {
            type: "number",
            default: 0,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        ENTITY_DIMENSION: {
            type: "string",
            default: "",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        ALGORITHM_TYPE: {
            type: "string",
            default: "",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Classification_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_Classification_Step]: {
            foreignKey: "WB_CLASSIFICATION_ID",
            foreignKeyImmutable: true,
            localField: "ClassificationSteps",
        },
    },
};

export const WB_Classification_Step = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Classification_Step", // optional
    description: "Schema for Classification records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLASSIFICATION_STEP_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CLASSIFICATION_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        PROCESS_ORDER: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "TRUE",
            },
        },
        WB_TAG_ID: {
            type: "number",
            default: 0,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Classification_Step_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Classification]: {
            foreignKey: "WB_CLASSIFICATION_ID",
            foreignKeyImmutable: true,
            localField: "Classification",
        },
        [PASchema.esWB_Tag]: {
            foreignKey: "WB_TAG_ID",
            foreignKeyImmutable: true,
            localField: "Tag",
        },
    },
    hasMany: {
        [PASchema.esWB_Classification_StepR]: {
            foreignKey: "WB_CLASSIFICATION_STEP_ID",
            foreignKeyImmutable: true,
            localField: "ClassificationStepRs",
        },
    },
};

export const WB_Classification_StepR = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "WB_Classification_StepR", // optional
    description: "Schema for Classification StepR records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLASSIFICATION_STEPR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CLASSIFICATION_STEP_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_ATTRIBUTEM_ID: {
            type: "number",
            default: 0,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        OPERATOR: {
            type: "string",
            default: "",
            length: 20,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 20,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        VALUE: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Classification_StepR_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Classification_Step]: {
            foreignKey: "WB_CLASSIFICATION_STEP_ID",
            foreignKeyImmutable: true,
            localField: "ClassificationStep",
        },
        [PASchema.esWB_AttributeType]: {
            foreignKey: "WB_ATTRIBUTEM_ID",
            foreignKeyImmutable: true,
            localField: "AttributeType",
        },
    },
};

export const WB_Classification_Control = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Classification Control", // optional
    description: "Schema for Classification Control records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLASSIFICATION_CONTROL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        CONTROL_POINT_ID: {
            type: "string",
            length: 256,
        },
        CONTROL_POINT_NAME: {
            type: "string",
            length: 256,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        ENTERPRISE_POLICY: {
            type: "string",
            length: 1,
        },
    },
});
export const WB_Classification_Control_JSData_RELs = {
    belongsTo: {},
    hasMany: {
        [PASchema.esWB_Classification_Control_Partition]: {
            foreignKey: "WB_CLASSIFICATION_CONTROL_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
};

export const WB_Classification_Control_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Classification Control Partition", // optional
    description: "Schema for Classification Control Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_CLASSIFICATION_CONTROLPR_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CLASSIFICATION_CONTROL_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_PARTITION_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_CLASSIFICATION_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        SORT_ORDER: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_Classification_Control_Partition_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_Classification_Control]: {
            foreignKey: "WB_CLASSIFICATION_CONTROL_ID",
            foreignKeyImmutable: true,
            localField: "ClassificationControl",
        },
    },
    hasMany: {},
};

// Event Volume
export const WB_EvtVolume = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Event Volume", // optional
    description: "Schema for Event Volume records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTVOLUME_ID: {
            type: "number",
            id: true,
            required: true,
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_MDSET_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        WB_SALESORG_ID: {
            type: "number",
            hdb: {
                dataType: "INTEGER",
                dataLength: 10,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_ID: {
            type: "string",
            length: 50,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 50,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        CONTROL_POINT_NAME: {
            type: "string",
            length: 256,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 256,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        COMMENTS: {
            type: "string",
            length: 512,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 512,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "TRUE",
            },
        },
        CREATED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        MODIFIED_DTTS: {
            type: "number",
            hdb: {
                dataType: "DECIMAL",
                dataLength: 15,
                dataScale: 0,
                nullable: "FALSE",
            },
        },
        DELETED_IND: {
            type: "string",
            length: 1,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 1,
                dataScale: null,
                nullable: "FALSE",
            },
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
            hdb: {
                dataType: "NVARCHAR",
                dataLength: 8,
                dataScale: null,
                nullable: "FALSE",
            },
        },
    },
});
export const WB_EvtVolume_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_EvtVolumePR]: {
            foreignKey: "WB_EVTVOLUME_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
    },
};

export const WB_EvtVolume_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Event Volume Partition", // optional
    description: "Schema for Event Volume Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_EVTVOLUMEPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_EVTVOLUME_ID: {
            type: "number",
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
        },
        SORT_ORDER: {
            type: "number",
        },
        BASE_PROCESS: {
            type: "string",
            length: 50,
        },
        BASE_ASSIGNMENT_PERCENT: {
            type: "string",
            length: 50,
        },
        EDLP_PROCESS: {
            type: "string",
            length: 50,
        },
        EDLP_ASSIGNMENT_PERCENT: {
            type: "string",
            length: 50,
        },
        MERCH_PROCESS: {
            type: "string",
            length: 50,
        },
        MERCH_ASSIGNMENT_PERCENT: {
            type: "string",
            length: 50,
        },
        SHIPPER_PROCESS: {
            type: "string",
            length: 50,
        },
        SHIPPER_ASSIGNMENT_PERCENT: {
            type: "string",
            length: 50,
        },
        BASE_WEEK_FITTING_OPTION: {
            type: "string",
            length: 50,
        },
        BASE_DATA_OFFSET_OPTION: {
            type: "string",
            length: 50,
        },
        EDLP_WEEK_FITTING_OPTION: {
            type: "string",
            length: 50,
        },
        EDLP_DATA_OFFSET_OPTION: {
            type: "string",
            length: 50,
        },
        MERCH_WEEK_FITTING_OPTION: {
            type: "string",
            length: 50,
        },
        MERCH_DATA_OFFSET_OPTION: {
            type: "string",
            length: 50,
        },
        SHIPPER_WEEK_FITTING_OPTION: {
            type: "string",
            length: 50,
        },
        SHIPPER_DATA_OFFSET_OPTION: {
            type: "string",
            length: 50,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_EvtVolume_Partition_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_EvtVolume]: {
            foreignKey: "WB_EVTVOLUME_ID",
            foreignKeyImmutable: true,
            localField: "EvtVolume",
        },
    },
};

// Volume Decomposition
export const WB_VolDecomp = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition", // optional
    description: "Schema for Volume Decomposition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMP_ID: {
            type: "number",
            id: true,
        },
        WB_MDSET_ID: {
            type: "number",
        },
        WB_SALESORG_ID: {
            type: "number",
        },
        WB_COMPANY_ID: {
            type: "number",
        },
        WB_SALESAREA_ID: {
            type: "number",
        },
        VOL_DECOMP_ID: {
            type: "string",
            length: 50,
        },
        VOL_DECOMP_NAME: {
            type: "string",
            length: 256,
        },
        COMMENTS: {
            type: "string",
            length: 512,
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecomp_JSData_RELs = {
    hasMany: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMP_ID",
            foreignKeyImmutable: true,
            localField: "Partitions",
        },
    },
    belongsTo: {
        [PASchema.esWB_MasterData_Set]: { foreignKey: "WB_MDSET_ID", foreignKeyImmutable: true, localField: "MDSet" },
        [PASchema.esWB_SalesOrg]: { foreignKey: "WB_SALESORG_ID", foreignKeyImmutable: true, localField: "SalesOrg" },
    },
};

export const WB_VolDecomp_Partition = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition Partition", // optional
    description: "Schema for Volume Decomposition Partition records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMP_ID: {
            type: "number",
        },
        WB_PARTITION_ID: {
            type: "number",
        },
        PROCESS_ID: {
            type: "string",
            length: 256,
        },
        STAGE_ID: {
            type: "number",
        },
        MANUAL_IND: {
            type: "string",
            length: 1,
        },
        ENABLED_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecomp_Partition_JSData_RELs = {
    belongsTo: {
        [PASchema.esWB_VolDecomp]: {
            foreignKey: "WB_VOL_DECOMP_ID",
            foreignKeyImmutable: true,
            localField: "VolDecomp",
        },
        [PASchema.esWB_Partition]: {
            foreignKey: "WB_PARTITION_ID",
            foreignKeyImmutable: true,
            localField: "Partition",
        },
    },
    hasOne: {
        [PASchema.esWB_VolDecompPR_BS_Default]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "BSDefault",
        },
        [PASchema.esWB_VolDecompPR_EDLP_Default]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "EDLPDefault",
        },
        [PASchema.esWB_VolDecompPR_Merch_Default]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "MerchDefault",
        },
        [PASchema.esWB_VolDecompPR_PassThrough_Default]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PassThroughDefault",
        },
    },
    hasMany: {
        [PASchema.esWB_VolDecompPR_BS_Detail]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "BSDetails",
        },
        [PASchema.esWB_VolDecompPR_EDLP_Detail]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "EDLPDetails",
        },
    },
};

export const WB_VolDecompPR_BS_Default = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR BS Default", // optional
    description: "Schema for Volume Decomposition PR BS Default records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_BS_DEFAULT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        VOLUME_ALPHA: {
            type: "number",
        },
        VOLUME_TOLERANCE: {
            type: "number",
        },
        PRICE_ALPHA: {
            type: "number",
        },
        PRICE_TOLERANCE: {
            type: "number",
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        METHOD: {
            type: "string",
            length: 50,
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        NUMBER_REF_WEEKS_BEFORE_DELTA: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_BS_Default_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
    },
};

export const WB_VolDecompPR_BS_Detail = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR BS Detail", // optional
    description: "Schema for Volume Decomposition PR BS Detail records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_BS_DETAIL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        VOLUME_ALPHA: {
            type: "number",
        },
        VOLUME_TOLERANCE: {
            type: "number",
        },
        PRICE_ALPHA: {
            type: "number",
        },
        PRICE_TOLERANCE: {
            type: "number",
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        METHOD: {
            type: "string",
            length: 50,
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        NUMBER_REF_WEEKS_BEFORE_DELTA: {
            type: "number",
        },
        USE_OVERRIDE_IND: {
            type: "string",
            length: 1,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_BS_Detail_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
        [PASchema.esWB_Customer]: {
            foreignKey: "WB_CUST_ID_PLANNING",
            foreignKeyImmutable: true,
            localField: "Customer",
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_VolDecompPR_EDLP_Default = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR EDLP Default", // optional
    description: "Schema for Volume Decomposition PR EDLP Default records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_EDLP_DEFAULT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        MARGIN: {
            type: "number",
        },
        E: {
            type: "number",
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_EDLP_Default_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
    },
};

export const WB_VolDecompPR_EDLP_Detail = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR EDLP Detail", // optional
    description: "Schema for Volume Decomposition PR EDLP Detail records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_EDLP_DETAIL_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        WB_CUST_ID_PLANNING: {
            type: "number",
        },
        WB_PROD_ID: {
            type: "number",
        },
        MARGIN: {
            type: "number",
        },
        E: {
            type: "number",
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        USE_OVERRIDE_IND: {
            type: "string",
            length: 1,
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_EDLP_Detail_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
        [PASchema.esWB_Customer]: {
            foreignKey: "WB_CUST_ID_PLANNING",
            foreignKeyImmutable: true,
            localField: "Customer",
        },
        [PASchema.esWB_Finished_Product]: {
            foreignKey: "WB_PROD_ID",
            foreignKeyImmutable: true,
            localField: "Product",
        },
    },
};

export const WB_VolDecompPR_Merch_Default = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR Merch Default", // optional
    description: "Schema for Volume Decomposition PR Merch Default records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_MERCH_DEFAULT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        ACV_THRESHOLD: {
            type: "number",
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_Merch_Default_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
    },
};

export const WB_VolDecompPR_PassThrough_Default = new Schema({
    $schema: "http://json-schema.org/draft-04/schema#", // optional
    title: "Volume Decomposition PR Pass Through Default", // optional
    description: "Schema for Volume Decomposition PR Pass Through Default records", // optional
    type: "object",
    track: true,
    properties: {
        WB_VOL_DECOMPPR_PASSTHROUGH_DEFAULT_ID: {
            type: "number",
            id: true,
            required: true,
        },
        WB_VOL_DECOMPPR_ID: {
            type: "number",
        },
        DELTA_END_DATE: {
            type: "string",
            default: "99991231",
            length: 8,
        },
        DELTA_NUMBER_OF_WEEKS: {
            type: "number",
        },
        CREATED_DTTS: {
            type: "number",
        },
        MODIFIED_DTTS: {
            type: "number",
        },
        DELETED_IND: {
            type: "string",
            length: 1,
        },
        DELETED_DT: {
            type: "string",
            default: "18000101",
            length: 8,
        },
    },
});
export const WB_VolDecompPR_PassThrough_Default_JSData_RELs = {
    hasMany: {},
    belongsTo: {
        [PASchema.esWB_VolDecompPR]: {
            foreignKey: "WB_VOL_DECOMPPR_ID",
            foreignKeyImmutable: true,
            localField: "PartitionR",
        },
    },
};

// Dictionaries
//-- Schemas
_.defaults(dctSchemaByEntitySet, {
    [PASchema.esWB_Partition]: WB_Partition,
    [PASchema.esWB_PartitionR]: WB_PartitionR,
    [PASchema.esWB_ControlPoint]: WB_Control_Point,
    [PASchema.esWB_ControlPoint_Partition]: WB_Control_Point_Partition,
    [PASchema.esWB_ControlPoint_Partition_Input]: WB_Control_Point_Partition_Input,
    [PASchema.esWB_ControlPoint_Type]: WB_Control_Point_Type,
    [PASchema.esWB_ControlPoint_Type_Process]: WB_Control_Point_Type_Process,
    [PASchema.esWB_ControlPoint_Type_Process_Input]: WB_Control_Point_Type_Process_Input,
    [PASchema.esWB_LE_Spend]: WB_LE_Spend,
    [PASchema.esWB_LE_Spend_Partition]: WB_LE_Spend_Partition,
    [PASchema.esWB_LE_Spend_Partition_Input]: WB_LE_Spend_Partition_Input,
    [PASchema.esWB_Act_Spend]: WB_Act_Spend,
    [PASchema.esWB_Act_Spend_Partition]: WB_Act_Spend_Partition,
    [PASchema.esWB_Act_Spend_Partition_Input]: WB_Act_Spend_Partition_Input,
    [PASchema.esWB_Classification_Control]: WB_Classification_Control,
    [PASchema.esWB_Classification_Control_Partition]: WB_Classification_Control_Partition,
    [PASchema.esWB_Classification]: WB_Classification,
    [PASchema.esWB_Classification_Step]: WB_Classification_Step,
    [PASchema.esWB_Classification_StepR]: WB_Classification_StepR,
    [PASchema.esWB_EvtVolume]: WB_EvtVolume,
    [PASchema.esWB_EvtVolumePR]: WB_EvtVolume_Partition,
    [PASchema.esWB_VolDecomp]: WB_VolDecomp,
    [PASchema.esWB_VolDecompPR]: WB_VolDecomp_Partition,
    [PASchema.esWB_VolDecompPR_BS_Default]: WB_VolDecompPR_BS_Default,
    [PASchema.esWB_VolDecompPR_BS_Detail]: WB_VolDecompPR_BS_Detail,
    [PASchema.esWB_VolDecompPR_EDLP_Default]: WB_VolDecompPR_EDLP_Default,
    [PASchema.esWB_VolDecompPR_EDLP_Detail]: WB_VolDecompPR_EDLP_Detail,
    [PASchema.esWB_VolDecompPR_Merch_Default]: WB_VolDecompPR_Merch_Default,
    [PASchema.esWB_VolDecompPR_PassThrough_Default]: WB_VolDecompPR_PassThrough_Default
});

//-- Table Names
_.defaults(dctTableNameByEntitySet, {
    [PASchema.esWB_Partition]: "/AZR/WB_PARTITION",
    [PASchema.esWB_PartitionR]: "/AZR/WB_PARTITIONR",
    [PASchema.esWB_ControlPoint]: "/AZR/WB_CONTROL_POINT",
    [PASchema.esWB_ControlPoint_Partition]: "/AZR/WB_CONTROL_POINTPR",
    [PASchema.esWB_ControlPoint_Partition_Input]: "/AZR/WB_CONTROL_POINTPIR",
    [PASchema.esWB_ControlPoint_Type]: "/AZR/WB_CONTROL_POINTM",
    [PASchema.esWB_ControlPoint_Type_Process]: "/AZR/WB_CONTROL_POINTMPR",
    [PASchema.esWB_ControlPoint_Type_Process_Input]: "/AZR/WB_CONTROL_POINTMPIR",
    [PASchema.esWB_LE_Spend]: "/AZR/WB_LE_SPEND",
    [PASchema.esWB_LE_Spend_Partition]: "/AZR/WB_LE_SPENDPR",
    [PASchema.esWB_LE_Spend_Partition_Input]: "/AZR/WB_LE_SPENDPSR",
    [PASchema.esWB_Act_Spend]: "/AZR/WB_ACT_SPEND",
    [PASchema.esWB_Act_Spend_Partition]: "/AZR/WB_ACT_SPENDPR",
    [PASchema.esWB_Act_Spend_Partition_Input]: "/AZR/WB_ACT_SPENDPSR",
    [PASchema.esWB_Classification_Control]: "/AZR/WB_CLASSIFICATION_CONTROL",
    [PASchema.esWB_Classification_Control_Partition]: "/AZR/WB_CLASSIFICATION_CONTROLPR",
    [PASchema.esWB_Classification]: "/AZR/WB_CLASSIFICATION",
    [PASchema.esWB_Classification_Step]: "/AZR/WB_CLASSIFICATION_STEP",
    [PASchema.esWB_Classification_StepR]: "/AZR/WB_CLASSIFICATION_STEPR",
    [PASchema.esWB_EvtVolume]: "/AZR/WB_EVTVOLUME",
    [PASchema.esWB_EvtVolumePR]: "/AZR/WB_EVTVOLUMEPR",
    [PASchema.esWB_VolDecomp]: "/AZR/WB_VOL_DECOMP",
    [PASchema.esWB_VolDecompPR]: "/AZR/WB_VOL_DECOMPPR",
    [PASchema.esWB_VolDecompPR_BS_Default]: "/AZR/WB_VOL_DECOMPPR_BS_DEFAULT",
    [PASchema.esWB_VolDecompPR_BS_Detail]: "/AZR/WB_VOL_DECOMPPR_BS_DETAIL",
    [PASchema.esWB_VolDecompPR_EDLP_Default]: "/AZR/WB_VOL_DECOMPPR_EDLP_DEFAULT",
    [PASchema.esWB_VolDecompPR_EDLP_Detail]: "/AZR/WB_VOL_DECOMPPR_EDLP_DETAIL",
    [PASchema.esWB_VolDecompPR_Merch_Default]: "/AZR/WB_VOL_DECOMPPR_MERCH_DEFAULT",
    [PASchema.esWB_VolDecompPR_PassThrough_Default]: "/AZR/WB_VOL_DECOMPPR_PASSTHROUGH_DEFAULT",
});

//-- Logical Key
_.defaults(dctLogicalKeysByEntitySet, {
    [PASchema.esWB_ControlPoint_Type]: ["CONTROL_POINT_TYPE_ID"],
    [PASchema.esWB_ControlPoint_Type_Process]: ["WB_CONTROL_POINTM_ID", "PROCESS_ID"],
    [PASchema.esWB_ControlPoint_Type_Process_Input]: ["WB_CONTROL_POINTMPR_ID", "INPUT_NAME"],
    [PASchema.esWB_Partition]: ["PARTITION_ID"],
    [PASchema.esWB_Classification_Control]: ["CONTROL_POINT_ID"],
    [PASchema.esWB_Classification_Control_Partition]: [
        "WB_CLASSIFICATION_CONTROL_ID",
        "WB_PARTITION_ID",
        "WB_CLASSIFICATION_ID",
    ],
});

//-- Other Foreign Keys without jsData  Relationship
_.defaults(dctNonParentForeignKeysByEntitySet, {
    [PASchema.esWB_ControlPoint_Partition]: {
        ["WB_PARTITION_ID"]: PASchema.esWB_Partition,
        ["WB_CONTROL_POINTMPR_ID"]: PASchema.esWB_ControlPoint_Type_Process,
    },
    [PASchema.esWB_LE_Spend]: {
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
        ["WB_SALESAREA_ID"]: PASchema.esWB_SalesArea,
    },
    [PASchema.esWB_Act_Spend]: {
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
        ["WB_SALESAREA_ID"]: PASchema.esWB_SalesArea,
    },
    [PASchema.esWB_Classification_Control]: {
        ["WB_SALESORG_ID"]: PASchema.esWB_SalesOrg,
        ["WB_MDSET_ID"]: PASchema.esWB_MasterData_Set,
    },
    [PASchema.esWB_Classification_Control_Partition]: {},
});

//-- Key Pools
_.defaults(dctMapperToKeyGenSpecs, {
    [PASchema.esWB_Partition]: { sequence_name: "/AZR/WB_PARTITION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_PartitionR]: { sequence_name: "/AZR/WB_PARTITIONR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ControlPoint]: { sequence_name: "/AZR/WB_CONTROL_POINT_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ControlPoint_Partition]: { sequence_name: "/AZR/WB_CONTROL_POINTPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ControlPoint_Partition_Input]: {
        sequence_name: "/AZR/WB_CONTROL_POINTPIR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_ControlPoint_Type]: { sequence_name: "/AZR/WB_CONTROL_POINTM_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_ControlPoint_Type_Process]: {
        sequence_name: "/AZR/WB_CONTROL_POINTMPR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_ControlPoint_Type_Process_Input]: {
        sequence_name: "/AZR/WB_CONTROL_POINTMPIR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_LE_Spend]: { sequence_name: "/AZR/WB_LE_SPEND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_LE_Spend_Partition]: { sequence_name: "/AZR/WB_LE_SPENDPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_LE_Spend_Partition_Input]: { sequence_name: "/AZR/WB_LE_SPENDPSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Act_Spend]: { sequence_name: "/AZR/WB_ACT_SPEND_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Act_Spend_Partition]: { sequence_name: "/AZR/WB_ACT_SPENDPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Act_Spend_Partition_Input]: { sequence_name: "/AZR/WB_ACT_SPENDPSR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Classification_Control]: {
        sequence_name: "/AZR/WB_CLASSIFICATION_CONTROL_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Classification_Control_Partition]: {
        sequence_name: "/AZR/WB_CLASSIFICATION_CONTROLPR_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_Classification]: { sequence_name: "/AZR/WB_CLASSIFICATION_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Classification_Step]: { sequence_name: "/AZR/WB_CLASSIFICATION_STEP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_Classification_StepR]: { sequence_name: "/AZR/WB_CLASSIFICATION_STEPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtVolume]: { sequence_name: "/AZR/WB_EVTVOLUME_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_EvtVolumePR]: { sequence_name: "/AZR/WB_EVTVOLUMEPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_VolDecomp]: { sequence_name: "/AZR/WB_VOL_DECOMP_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_VolDecompPR]: { sequence_name: "/AZR/WB_VOL_DECOMPPR_SEQ", ...KeyGenSpecs_default },
    [PASchema.esWB_VolDecompPR_BS_Default]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_BS_DEFAULT_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_VolDecompPR_BS_Detail]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_BS_DETAIL_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_VolDecompPR_EDLP_Default]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_EDLP_DEFAULT_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_VolDecompPR_EDLP_Detail]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_EDLP_DETAIL_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_VolDecompPR_Merch_Default]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_MERCH_DEFAULT_SEQ",
        ...KeyGenSpecs_default,
    },
    [PASchema.esWB_VolDecompPR_PassThrough_Default]: {
        sequence_name: "/AZR/WB_VOL_DECOMPPR_PASSTHROUGH_DEFAULT_SEQ",
        ...KeyGenSpecs_default,
    },
});

// Add Section for Custom Columns if needed
